var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUploadImage = function SvgUploadImage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5933",
    "data-name": "Group 5933",
    transform: "translate(-37 -567)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6410",
    "data-name": "Rectangle 6410",
    width: 40,
    height: 40,
    rx: 20,
    transform: "translate(37 567)",
    fill: "#82cecf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "add_2_",
    "data-name": "add (2)",
    d: "M13.613,0H2.521A2.524,2.524,0,0,0,0,2.521v8.824a2.524,2.524,0,0,0,2.521,2.521H8.508a.63.63,0,0,0,.5-1.016L7.358,10.719l4.569-5.812,2.947,3.515V9.485a.63.63,0,1,0,1.261,0V2.521A2.524,2.524,0,0,0,13.613,0ZM12.395,3.5a.63.63,0,0,0-.978.015L6.563,9.691,4.91,7.556a.63.63,0,0,0-.5-.245h0a.63.63,0,0,0-.5.246L2.525,9.36a.63.63,0,0,0,1,.769l.889-1.156,2.811,3.632h-4.7a1.262,1.262,0,0,1-1.261-1.261V2.521A1.262,1.262,0,0,1,2.521,1.261H13.613a1.262,1.262,0,0,1,1.261,1.261V6.46ZM4.412,2.269A1.891,1.891,0,1,0,6.3,4.16,1.893,1.893,0,0,0,4.412,2.269Zm0,2.521a.63.63,0,1,1,.63-.63A.631.631,0,0,1,4.412,4.79Zm11.723,7.216a.63.63,0,0,1-.63.63H13.771V14.37a.63.63,0,0,1-1.261,0V12.637H10.777a.63.63,0,1,1,0-1.261h1.733V9.643a.63.63,0,1,1,1.261,0v1.733H15.5A.63.63,0,0,1,16.134,12.006Zm0,0",
    transform: "translate(49 580)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUploadImage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/upload-image.ade807c3.svg";
export { ForwardRef as ReactComponent };